'use es6';

import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { getIntegrationPropertiesById, createGetIntegrationPropertiesById } from 'reference-resolvers/api/IntegrationsAPI';
import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
export const createIntegrationPropertyReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.INTEGRATION_PROPERTIES,
  createFetchByIds: createGetIntegrationPropertiesById,
  fetchByIds: getIntegrationPropertiesById
}, options));
export default createIntegrationPropertyReferenceResolver();